/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const UploadIcon = ({
  className,
  style,
  color = '#3A50F3',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M3.10957 5.75073L7.73457 1.11011C7.88145 0.963232 8.11895 0.963232 8.26582 1.11011L12.8908 5.75073C13.0377 5.89761 13.0377 6.13511 12.8908 6.28198L12.6689 6.50386C12.5221 6.65073 12.2846 6.65073 12.1377 6.50386L8.53145 2.87886V12.6257C8.53145 12.832 8.3627 13.0007 8.15645 13.0007H7.84395C7.6377 13.0007 7.46895 12.832 7.46895 12.6257L7.46895 2.87886L3.8627 6.50073C3.71582 6.64761 3.47832 6.64761 3.33145 6.50073L3.10957 6.27886C2.9627 6.13511 2.9627 5.89761 3.10957 5.75073Z"
        fill={color}
      />
      <path
        d="M2 14.5C2 14.2239 2.22386 14 2.5 14H13.5C13.7761 14 14 14.2239 14 14.5C14 14.7761 13.7761 15 13.5 15H2.5C2.22386 15 2 14.7761 2 14.5Z"
        fill={color}
      />
    </svg>
  );
};
